import { render, staticRenderFns } from "./ReportDocumental.vue?vue&type=template&id=7fac359e&scoped=true&"
import script from "./ReportDocumental.vue?vue&type=script&lang=js&"
export * from "./ReportDocumental.vue?vue&type=script&lang=js&"
import style0 from "./ReportDocumental.vue?vue&type=style&index=0&id=7fac359e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac359e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
